module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/rooster.e6ff9660.jpg";